import { render, staticRenderFns } from "./openAdd.vue?vue&type=template&id=062de3e2&scoped=true&"
import script from "./openAdd.vue?vue&type=script&lang=js&"
export * from "./openAdd.vue?vue&type=script&lang=js&"
import style0 from "./openAdd.vue?vue&type=style&index=0&id=062de3e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062de3e2",
  null
  
)

export default component.exports